var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-200"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-200",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hourglass--inject-200"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.59,320.73s-73.49,43.39-73.49,84.5h147C343.09,364.12,269.59,320.73,269.59,320.73Z",
    style: {
      fill: "#56A9A2",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.59,372.5s-67.86,16.81-67.86,32.73H337.45C337.45,389.31,269.59,372.5,269.59,372.5Z",
    style: {
      fill: "#56A9A2",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.51,332.71c13.8,13.57,40.62,43.64,40.62,72.52H300.74C300.74,376.35,286.06,346.28,278.51,332.71Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.59,320.73s-73.49-43.39-73.49-84.5h147C343.09,277.34,269.59,320.73,269.59,320.73Z",
    style: {
      fill: "#56A9A2",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.59,316.77s-37.52-18-37.52-35.1h75.05C307.12,298.74,269.59,316.77,269.59,316.77Z",
    style: {
      fill: "#56A9A2",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.58,308.75C247.79,295.18,221,265.11,221,236.23h18.39C239.35,265.11,254,295.18,261.58,308.75Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.51,308.75c13.8-13.57,39.95-47.12,40.62-72.52h-4.9C311.93,267.2,289.43,295.62,278.51,308.75Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.78,
    y: 221.72,
    width: 8.33,
    height: 1,
    style: {
      fill: "#56A9A2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.39,235.46h-1a12.75,12.75,0,0,0-12.73-12.74h-8.79v-1h8.79A13.76,13.76,0,0,1,361.39,235.46Z",
    style: {
      fill: "#56A9A2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.29,
    y: 225.22,
    width: 176.6,
    height: 22.02,
    rx: 10.24,
    style: {
      fill: "#56A9A2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.29,
    y: 394.22,
    width: 176.6,
    height: 22.02,
    rx: 10.24,
    style: {
      fill: "#56A9A2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-200"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "140.72 304.52 133.94 298.5 145.5 280.75 152.28 286.76 140.72 304.52",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.34,294.68l8.62,6a.66.66,0,0,1,.21.91l-4.32,7.12a1.66,1.66,0,0,1-2.29.43c-3-2.13-4.11-3.17-7.7-6.07a133.3,133.3,0,0,1-10.2-8.89c-2.66-2.76.15-5.43,1.56-4.48,3.33,2.26,9.12,4.75,12.47,4.55A2.6,2.6,0,0,1,135.34,294.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.27 286.77 145.49 280.75 139.93 289.3 146.88 295.07 152.27 286.77",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.25,198.1s-45.5-3.11-51.14,12.31c-12.83,35.06-29.52,72.25-29.52,72.25L154,292.37s28.35-43.35,37-71.18c17.5,4.25,49.14,7.88,59.33-3.82,8.7-10,2.19-19.27,2.19-19.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.28,225.35c-1.06,4.28-2.67,16.54-3.67,24.67,2.21-4.28,4.31-8.62,6.2-12.86Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.14 296.76 137.93 284.84 141.04 278.16 158.04 291.15 153.14 296.76",
    style: {
      fill: "#56A9A2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69,294.13a12.24,12.24,0,0,0,2.24,1.15.22.22,0,0,0,.28-.28c-.13-.34-1.27-3.33-2.46-3.62a.83.83,0,0,0-.77.22,1.22,1.22,0,0,0-.45,1.13A2.56,2.56,0,0,0,131.69,294.13Zm1.93.55c-1.57-.68-2.55-1.43-2.66-2a.78.78,0,0,1,.32-.73.38.38,0,0,1,.37-.11C132.29,292,133.12,293.49,133.62,294.68Z",
    style: {
      fill: "#56A9A2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.88,295.25a.18.18,0,0,0,.1,0,.23.23,0,0,0,.2-.08c.07-.08,1.77-2.17,1.52-3.46a1.1,1.1,0,0,0-.59-.77.83.83,0,0,0-1,.09c-.76.71-.73,3.11-.28,4.1A.27.27,0,0,0,133.88,295.25Zm1.11-3.83a.65.65,0,0,1,.28.42c.15.76-.66,2.07-1.19,2.79-.28-1-.19-2.78.3-3.24.1-.09.24-.18.53,0Z",
    style: {
      fill: "#56A9A2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.5 315.01 191.75 316.76 190.13 293.33 199.02 293.61 200.5 315.01",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.56,313.56l10-4.21a.68.68,0,0,1,.92.33l3.82,7.68a1.72,1.72,0,0,1-.89,2.24c-3.5,1.41-5.24,1.9-9.63,3.76-2.7,1.14-10,4.44-13.9,5.41s-4.78-2.94-3.2-3.7c3.74-1.8,9.94-7.29,11.61-10.32A2.77,2.77,0,0,1,190.56,313.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.07,316.44a12.27,12.27,0,0,0,2.23-1.32.24.24,0,0,0,.09-.23.24.24,0,0,0-.18-.17c-.36-.08-3.6-.73-4.51.15a.83.83,0,0,0-.23.79,1.23,1.23,0,0,0,.73,1A2.62,2.62,0,0,0,188.07,316.44Zm1.53-1.38c-1.45,1-2.64,1.43-3.23,1.2a.79.79,0,0,1-.46-.68.4.4,0,0,1,.1-.39C186.5,314.72,188.3,314.84,189.6,315.06Z",
    style: {
      fill: "#56A9A2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.25,315.15a.31.31,0,0,0,.09-.07.23.23,0,0,0,0-.21c0-.11-.92-2.75-2.18-3.24a1.11,1.11,0,0,0-1,.09.84.84,0,0,0-.48.94c.2,1,2.31,2.35,3.42,2.5A.2.2,0,0,0,190.25,315.15Zm-2.73-3.09a.67.67,0,0,1,.52,0c.75.29,1.44,1.72,1.78,2.58-1-.33-2.53-1.36-2.66-2.06,0-.13,0-.3.27-.46Z",
    style: {
      fill: "#56A9A2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.03 293.62 190.13 293.33 190.98 305.57 199.84 305.41 199.03 293.62",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.35,198.1s-65,6.15-62.66,25.72c3.42,28.23,5.92,77.66,5.92,77.66l16.57.65s6.22-43.46,2.58-72.37c16.83,0,53.39.89,59.82-7.81,7.63-10.32,4.1-23.85,4.1-23.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.01 303.15 185.12 302.16 184.41 293.51 206.22 295.01 205.01 303.15",
    style: {
      fill: "#56A9A2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.92,140.79c-.14,1.79-.3,3.38-.52,5.05s-.43,3.3-.69,4.95c-.48,3.29-1.14,6.56-1.88,9.85s-1.65,6.57-2.79,9.88a52.65,52.65,0,0,1-4.53,10,25,25,0,0,1-4,5.09,15.39,15.39,0,0,1-1.29,1.08c-.41.34-.82.63-1.24.92a25.52,25.52,0,0,1-2.49,1.55,48.42,48.42,0,0,1-10,4.07c-1.65.51-3.31.92-5,1.29s-3.3.69-5,.95a80.44,80.44,0,0,1-10,1,3.42,3.42,0,0,1-1.2-6.67l.13-.05a160.67,160.67,0,0,0,17.23-6.56,47,47,0,0,0,7.38-4.18c.53-.38,1-.77,1.48-1.16.22-.19.45-.38.64-.58a5.66,5.66,0,0,0,.5-.51,13.72,13.72,0,0,0,1.7-2.61,43,43,0,0,0,2.91-7.69c.81-2.81,1.51-5.74,2.09-8.72s1.1-6,1.59-9.06.86-6.18,1.2-9.08l0-.17a6.87,6.87,0,0,1,13.66,1.36Z",
    style: {
      fill: "#56A9A2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.82,188l-5,.31,4,9.2s8.65-.19,8.47-4.45l-1.56-2A8.14,8.14,0,0,0,179.82,188Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.34 189.07 173.66 197.53 178.81 197.53 174.81 188.33 169.34 189.07",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.2,126.61l9.67-2,7.7-1.11a14.28,14.28,0,0,1,3.33-.15A14.58,14.58,0,0,1,261.64,134c1.93,7,3.67,15.59,5,23.2,1.86,10.57,2.82,26.45,3,40.89H223.83c-1-26.15-6.56-43-8.45-53.45a14.62,14.62,0,0,1,8.09-15.79Z",
    style: {
      fill: "#56A9A2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.83,132.36c.11,4.3,1,19.63,5.61,28.34.81-8.16,10.5-33,10.5-33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.69,164.38h0c0-.16,0-.31-.06-.48l-.09-.72c-.05-.39-.1-.78-.15-1.15l-.15-1.07-.15-1c0-.28-.09-.57-.13-.84-.1-.64-.2-1.26-.31-1.87-.33-1.87-.68-3.81-1.06-5.76l0-.16c-.38-2-.77-3.93-1.19-5.88l0-.13c-.17-.84-.35-1.66-.54-2.49l-.21-.92-.36-1.59-.3-1.24-.06-.26h0c-.4-1.64-.81-3.25-1.23-4.77l-6.95-3.66c.8,3.07,1.56,6.45,2.28,9.91a10.15,10.15,0,0,0-2.28,1.63c-1.66,1.48-1.6,4.63.06,8.36A92.45,92.45,0,0,1,262.31,184c.21,4.71.34,9.48.4,14.11h7C269.51,186.64,268.87,174.28,267.69,164.38Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.27,107.34l-3.93,6L225,121.49a8.35,8.35,0,0,1,1.65,2.41c1,2,1.78,3.44-2.35,6.25-.88.6-.91,1.55-.71,2.6.24,1.28,1,2.62,5.44,1.83a20.55,20.55,0,0,0,11.18-6.2c1.48-1.49,1.14-2.6-.29-4.14C235.88,119.89,234.67,112.94,234.27,107.34Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.83,134.73l2.83,1.78,4.6-1.95a7.43,7.43,0,0,0-4-2.09A7.92,7.92,0,0,0,224.83,134.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.21,132.47c2.11.87,3.17,2.83,4.13,5.09,0,0,10.11-7.66,10.32-12.71-.54-1.72-3.07-1.42-3.07-1.42S236.51,128.77,228.21,132.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.21,132.47a5.13,5.13,0,0,0-3.2,5s-4.5-5.28-.84-9.27a13.28,13.28,0,0,1,3.14-1.17S226.21,129.23,228.21,132.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.55,135.68h-1.29c-.42.72-1,10.1-1.23,15.09a44.67,44.67,0,0,0,2.71,8.49.42.42,0,0,0,0,.1c.07.16.14.31.22.46.14.3.28.6.44.88a56.41,56.41,0,0,1,2.15-9.13C230.23,145.79,228.55,135.68,228.55,135.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.32,119.48l3.28-5.81c.06.14.14.31.22.47a15.93,15.93,0,0,1,.7,2.23c.6,2.59-1.4,6.27-3.61,8-.09-.16-.17-.33-.26-.5a10,10,0,0,0-1.51-2.32l-.13-.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.34,107c-.79-3.55,4.86-8.46,4.86-8.46l-6.69-2.33C205.49,98.38,207.45,104.57,210.34,107Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.88,96.74c1.58,8.88,3,14-.34,19.67a11.71,11.71,0,0,1-20.73-.6c-3.75-7.32-5.7-20.6,1.93-26.43A11.85,11.85,0,0,1,232.88,96.74Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,105.72l-4.2-1.15v-5.4s-5.31-3-4.49-6.75a41,41,0,0,1,1.71-6.2s8.42-.54,11,.54a18.29,18.29,0,0,1-2.17,2,19.14,19.14,0,0,1,5.1,5.22,7,7,0,0,0-2.88,1.39S238.17,102.78,233,105.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.34,80.46c3.09,1.94,1.3,5.5,1.3,5.5l8.27.17C232.47,83.52,225.3,80.33,223.34,80.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.57,94.24c-.59,1.66-7.29,3.7-13.4,3.9a27.72,27.72,0,0,1-8.92-1.68,10.2,10.2,0,0,1,3-2.13c-3.69-.91-8.36-4.15-9.65-6.79A15.28,15.28,0,0,1,206,87a9,9,0,0,1-3.17-6.21s15.64,6.2,21.66,3.63c6.54-2.8,11.51,2.45,7.21,6.45S226.57,94.24,226.57,94.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.66,103.17a8,8,0,0,1-1.79,5.4c-1.62,1.93-4.14.39-4.72-2-.52-2.17.16-5.52,2.29-6.56S237.55,100.74,237.66,103.17Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.36,105c.22.7,0,1.39-.4,1.56s-1-.27-1.23-1,0-1.39.4-1.56S219.13,104.26,219.36,105Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.61,107.8c.22.69,0,1.39-.4,1.55s-1-.26-1.23-1,0-1.39.4-1.55S211.38,107.1,211.61,107.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.26,107.43a23.4,23.4,0,0,1-.72,6.14,3.51,3.51,0,0,0,2.92-.69Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,115.55a6.35,6.35,0,0,0,3.7-3.26.22.22,0,0,0-.12-.28.21.21,0,0,0-.28.11,6,6,0,0,1-4.21,3.24.21.21,0,0,0-.16.26.21.21,0,0,0,.25.16A6.54,6.54,0,0,0,219,115.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.08,100.9a.43.43,0,0,0,.15-.15.42.42,0,0,0-.12-.59,4.15,4.15,0,0,0-3.86-.4.43.43,0,0,0,.37.78,3.25,3.25,0,0,1,3,.34A.43.43,0,0,0,221.08,100.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.07,103.59a.39.39,0,0,0,0-.21.43.43,0,0,0-.56-.23,4.1,4.1,0,0,0-2.52,2.94.43.43,0,0,0,.84.14,3.29,3.29,0,0,1,2-2.29A.43.43,0,0,0,210.07,103.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.51,129.7c1.1,1.36,2.06,2.59,3,3.9s1.92,2.61,2.84,3.94c1.87,2.65,3.61,5.4,5.31,8.2s3.28,5.72,4.7,8.81a54.29,54.29,0,0,1,3.65,10,26.49,26.49,0,0,1,.78,6.12,23.55,23.55,0,0,1-.88,6.1,40.43,40.43,0,0,1-4.32,9.84c-.86,1.47-1.79,2.88-2.76,4.24s-2,2.68-3,3.95a68.45,68.45,0,0,1-6.79,7.18,3.43,3.43,0,0,1-5.25-4.28l.09-.15A115.84,115.84,0,0,0,265,181.79a35.43,35.43,0,0,0,2.24-7.65,13.72,13.72,0,0,0,.13-3.19,15.56,15.56,0,0,0-.68-3.1,46.17,46.17,0,0,0-3.25-7.4c-1.33-2.51-2.83-5-4.43-7.53s-3.28-5-5-7.43l-2.63-3.66c-.88-1.19-1.8-2.46-2.63-3.55l-.06-.08a6.86,6.86,0,0,1,10.78-8.5Z",
    style: {
      fill: "#56A9A2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.23,203.47l85.08-3.85a2,2,0,0,1,2.13,1.94l-89.15,4A2,2,0,0,1,164.23,203.47Z",
    style: {
      fill: "#56A9A2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.23,203.47l85.08-3.85a2,2,0,0,1,2.13,1.94l-89.15,4A2,2,0,0,1,164.23,203.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.69,164l60.53-2.74a1.89,1.89,0,0,1,1.76,1.27L224.6,199.4a1,1,0,0,1-.93,1.38l-60.53,2.74a1.87,1.87,0,0,1-1.75-1.26l-11.62-36.88A1,1,0,0,1,150.69,164Z",
    style: {
      fill: "#56A9A2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.69,164l60.53-2.74a1.89,1.89,0,0,1,1.76,1.27L224.6,199.4a1,1,0,0,1-.93,1.38l-60.53,2.74a1.87,1.87,0,0,1-1.75-1.26l-11.62-36.88A1,1,0,0,1,150.69,164Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,162.52l11.62,36.87a1,1,0,0,1-.93,1.39l-12.45-39.53A1.89,1.89,0,0,1,213,162.52Z",
    style: {
      fill: "#56A9A2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.94,200.63l22.37-1a2,2,0,0,1,2.13,1.94L225,202.76A2,2,0,0,1,226.94,200.63Z",
    style: {
      fill: "#56A9A2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.2,197.28l-5.72.83,5.86,8.15s9.31-1.49,8.23-5.62l-2-1.66A8.12,8.12,0,0,0,255.2,197.28Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.48 200.55 249.65 206.8 255.34 206.26 249.48 198.11 242.48 200.55",
    style: {
      fill: "#ff8b7b"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeImage);
export default __webpack_public_path__ + "static/media/time-image.64750af81e9419e4dd6cce099068638f.svg";
export { ForwardRef as ReactComponent };